import { usePrinterStore } from '@/stores/printer';
import { logInfo, logError } from '@/utils/logger';

let isRunning = false;

export const CleanWorker = async () => {
  if (isRunning) return;

  try {
    isRunning = true;

    // Calculate timestamp for 15 minutes ago
    const fifteenMinutesAgo = Date.now() - (15 * 60 * 1000); // 15 minutes in milliseconds
    const printerStore = usePrinterStore();
    const printJobService = await printerStore.getPrintJobService();

    // Count receipt printer records to be deleted for logging
    const recordsToDelete = await printJobService.table
      .where('created_at_timestamp')
      .below(fifteenMinutesAgo)
      .count();

    if (recordsToDelete > 0) {
      // Delete receipt printer records older than 15 minutes
      await printJobService.table
        .where('created_at_timestamp')
        .below(fifteenMinutesAgo)
        .delete();

      logInfo('Clean worker completed', {
        recordsDeleted: recordsToDelete,
        cutoffDate: new Date(fifteenMinutesAgo).toISOString(),
      });
    } else {
      logInfo('Clean worker completed - no records to delete', {
        cutoffDate: new Date(fifteenMinutesAgo).toISOString(),
      });
    }

  } catch (error) {
    logError('Error in clean worker:', { error });
  } finally {
    isRunning = false;
  }
};
